import { client, useConfig, useElementData } from '@sigmacomputing/plugin'
import { useEffect } from 'react'
import { themeOptions, themes } from '../utilities'
import '../data-viz/components/MetricBreakdown'
  
export default function App() {

    useEffect(() => {
        client.config.configureEditorPanel([
            {
                name: "source",
                type: "element",
            },
            {
                name: "chats",
                type: "column",
                source: "source",
                allowMultiple: false,
            },
            {
                name: "calls",
                type: "column",
                source: "source",
                allowMultiple: false,
            },
            {
                name: "emails",
                type: "column",
                source: "source",
                allowMultiple: false,
            },
            {
                name: 'theme',
                type: 'dropdown',
                values: themeOptions
            },
            {
                name: 'helpText',
                type: 'text',
                secure: false, 
                multiline: false, 
                placeholder: '',
                defaultValue: ''
            }
        ])
    }, [])
        
    const config = useConfig()
    const sigmaData = useElementData(config.source)

    const { chats, calls, emails, theme, helpText } = config

    let chatsVal, callsVal, emailsVal

    if(Object.keys(sigmaData).length) {
        chatsVal = sigmaData[chats][0]
        callsVal = sigmaData[calls][0]
        emailsVal = sigmaData[emails][0]
    }

    return (
        <>
        <zero-metric-breakdown
            data-fill={themes[theme]?.dark}
            data-bg={themes[theme]?.light}
            data-heading="PHA Interactions"
            data-format="decimal"
            data-values={[chatsVal,callsVal,emailsVal]}
            data-labels="Chats,Calls,Emails"
            data-help={helpText}></zero-metric-breakdown>
        </>
    )
}
